import React from 'react';
import {useController} from "react-hook-form";
import _ from "lodash";
import SearchSelect from "../../../components/searchSelect";
import Form from "react-bootstrap/Form";



const RustarFormParsItem = ({formController,prefix,strData,countryTypes}) => {
  const {control,
    register,
    getValues,
    setValue,
    setError,
    handleSubmit,
    formState:{errors}} = formController
  const {
    field: { onChange: typeOnChange, value: typeValue }
  } = useController({
    name: `${prefix}.countryType`,
    control,
    rules: { required: true },
    defaultValue:_.find(countryTypes,{value:"UAE"})
  });

  return (
    <div className={'d-flex align-items-center gap-2 mb-2'}>
      <div style={{minWidth: '7rem'}}>
        <SearchSelect
          onChange={(v) => {
            typeOnChange(v)
          }}
          defaultValue={typeValue}
          hasError={_.get(errors, `${prefix}.countryType`)}
          label={'Тип'}
          array={countryTypes}/>
      </div>
      <Form.Control
        as="textarea"
        rows="1"
        defaultValue={strData.text}
        placeholder={'Введите текст'}
        {...register(`${prefix}.text`,{
          // onChange: (e)=>{console.log(e.target.value)}
        })}
      />

    </div>
  );
};

export default RustarFormParsItem;
